"use client";

interface TimelineProps {
    data: {
        timelineImage: Picture;
        timelineList: {
            title: string;
        }[]
    }
}

interface Picture {
    data: {
        id: string;
        attributes: {
            url: string;
            name: string;
            alternativeText: string;
        };
    };
}

export default function TimelineComponent({ data }: TimelineProps) {
    return (
        <div className="flex justify-center max-sm:px-5 py-10">
            <div className="max-w-6xl mx-auto">
                <div className="grid grid-cols-[1fr_auto_1fr] gap-8 items-center">
                    <div className="grid grid-rows-2 gap-40">
                        <div>
                            <div className="flex text-end text-xl text-[#032D60] pb-[10px]">
                                {data.timelineList[1].title}
                            </div>
                            <div className="border-t-2 border-dashed border-gray-300"></div>
                        </div>
                        <div>
                            <div className="flex text-end text-xl text-[#032D60] pb-[10px]">
                                {data.timelineList[3].title}
                            </div>
                            <div className="border-t-2 border-dashed border-gray-300"></div>
                        </div>
                    </div>

                    <img width={78} height={691} src={data.timelineImage.data.attributes.url} />

                    <div className="grid grid-rows-3 gap-32">
                        <div className="flex flex-col justify-center">
                            <div className="flex text-start text-xl text-[#032D60] pb-[10px]">
                                {data.timelineList[0].title}
                            </div>
                            <div className="border-t-2 border-dashed border-gray-300"></div>
                        </div>
                        <div className="flex flex-col justify-center">
                            <div className="flex text-start text-xl text-[#032D60] pb-[10px]">
                                {data.timelineList[2].title}
                            </div>
                            <div className="border-t-2 border-dashed border-gray-300"></div>
                        </div>
                        <div className="flex flex-col justify-center">
                            <div className="flex text-start text-xl text-[#032D60] pb-[10px]">
                                {data.timelineList[4].title}
                            </div>
                            <div className="border-t-2 border-dashed border-gray-300"></div>
                        </div>
                        
                    </div>
                </div>

            </div>
        </div>
    )
}